module.exports = __webpack_public_path__ + "static/media/1_A1_09.1eb44b36.png";